// extracted by mini-css-extract-plugin
export var bgWrapper = "style-module--bgWrapper--q18ma";
export var divider = "style-module--divider--GJ104";
export var dotsWrapper2 = "style-module--dotsWrapper2--5AzIi";
export var header = "style-module--header--JWliB";
export var highlight = "style-module--highlight--ujVnI";
export var img = "style-module--img--nSu2O";
export var imgWrapper = "style-module--imgWrapper--fpyUY";
export var place = "style-module--place--sRYop";
export var project = "style-module--project--Ir91I";
export var projectTitle = "style-module--projectTitle--giutj";
export var root = "style-module--root--saQQS";
export var summaryText = "style-module--summaryText--1Bx3b";
export var text = "style-module--text--CJrKb";
export var title = "style-module--title--s9RjD";
export var winners = "style-module--winners--5Ojvc";
export var winnersImg = "style-module--winnersImg--1GkHh";
export var winnersTitle = "style-module--winnersTitle--U0tCo";